import types from '../actions/types';
import {
    multipleResultReducer,
    multipleResultInitialState
} from './common/multiple-results';

const initial_state = {
    partners: multipleResultInitialState
}

export default function(state = initial_state, action) {
    switch (action.type) {

        default:
            return {
                ...state,
                partners: multipleResultReducer(state.partners, types.LOAD_PARTNERS, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/partner.js